import React from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

const Card = ({ imageSrc, imageSrc2, title, description, isExpanded, toggleCard }) => {
  return (
    <div
      className={`relative mx-auto w-full transition-all duration-300`} // Removed dynamic height classes
    >
      {!isExpanded ? (
        <div className="relative rounded overflow-hidden shadow-lg bg-white w-full transition-all duration-300 z-10">
          <img
            className="rounded-lg max-h-[35vh] w-full object-cover"
            src={imageSrc}
            alt="Students learning"
          />
          <div className="px-6 py-6">
            <div className="font-bold text-3xl mt-5 mb-2 text-black">{title}</div>
          </div>
          <div className="px-6 pt-4 pb-2 flex justify-between">
            <button
              onClick={toggleCard}
              className="flex items-center justify-center text-white bg-black rounded-full w-[40px] h-[40px]"
            >
              <FaArrowUp />
            </button>
          </div>
        </div>
      ) : (
        <div className="relative rounded overflow-hidden shadow-lg bg-[#3F3F3F] w-full transition-all duration-300 z-20">
          <img
            className="rounded-lg max-h-[35vh] w-full object-cover"
            src={imageSrc2}
            alt="Students learning"
          />
          <div className="px-6 py-6">
            <div className="font-bold text-3xl mt-5 mb-2 text-white">{title}</div>
            <p className="text-white text-base mt-5 text-justify">{description}</p>
          </div>
          <div className="px-6 pt-4 pb-2 flex justify-between">
            <button
              onClick={toggleCard}
              className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px]"
            >
              <FaArrowDown />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;